<template>
  <div class="row mt-5">
    <div class="col-1"></div>
    <div class="col-10">
      <base-button v-b-toggle.collapse-cate  block class="btn-primary"> Categorias</base-button>
      <b-collapse id="collapse-cate">
      <b-card title="Categorias" sub-title="Crear categoria">
        <div class="row">
          <div class="col-4">
            <ValidationObserver v-slot="{ invalid }">
              <form @submit.prevent="onSubmit">
                <div class="col-12">
                  <label for="name">Nombre Categotia</label>
                  <ValidationProvider name="category.category" rules="required" v-slot="{ errors }">
                    <input
                        id="name"
                        v-model="category.category"
                        type="text"
                        class="form-control"
                    >
                    <p>{{ errors[0] }}</p>
                  </ValidationProvider>
                </div>

                <div class="col-12">
                  <base-button type="primary btn_submit" @click="onSubmit"
                               :disabled="invalid">Guardar
                  </base-button>
                </div>
              </form>
            </ValidationObserver>
          </div>
          <div class="col-8">
            <div class="table-responsive table-flush">
              <base-table class="table align-items-center"
                          thead-classes="table-light"
                          tbody-classes="list"
                          :data="categorys">
                <template slot="columns">
                  <th>Nombre</th>
                  <th></th>
                </template>
                <template slot-scope="{row}">
                  <th scope="row">
                    <div class="media align-items-center">
                      <div class="media-body">
                        <span class="name mb-0 text-sm">{{ row.category }}</span>
                      </div>
                    </div>
                  </th>
                  <td>
                    <div class="btn_icon_edit" @click="EditCategory(row)"></div>
                  </td>

                </template>
              </base-table>
            </div>
          </div>
        </div>
      </b-card>
      </b-collapse>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import {bus} from "@/components/Configuration/bus_configuration";
import {configuration_service} from "@/services/configuration/ConfigurationService";
import {extend, ValidationProvider} from 'vee-validate'
import {ValidationObserver} from 'vee-validate'
import {required} from 'vee-validate/dist/rules'
import swal from "sweetalert";

extend('required', {
  ...required,
  message: 'Este campo es requerido'
})
export default {
  name: "Categoria",
  components: {ValidationProvider, ValidationObserver},
  data() {
    return {
      categorys: [],
      category: {
        category: ''
      }
    }
  },
  methods: {
    onSubmit() {
      configuration_service.CreateCategory(this.category)
    },
    EditCategory(row) {
      this.category.category = row.category
      this.category.category_id = row.category_id
    },
    cleandata() {
      this.category = {
        category: ''
      }
    }
  },
  created() {
    configuration_service.GetAllCategorys()
    bus.$on('GetAllCategorys', (response) => {
      this.categorys = response
    })
    bus.$on('CreateCategory', (response) => {
      configuration_service.GetAllCategorys()
      this.cleandata()
      if (response) {
        swal({
          icon: "success",
          text: "Se Han Guardado los datos correctamente",
          button: "Aceptar"
        })
      }
    })
  }
}
</script>

<style scoped>

</style>